import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-heating',
  templateUrl: './heating.component.html',
  styleUrls: ['./heating.component.scss']
})
export class HeatingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
